import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Globals } from '.././globals';
import { commonService } from '../service/common.service';
@Injectable()
export class GroupService {

  user: any;
  reqHeader = new HttpHeaders({ 'No-Auth': 'True' });

  constructor(private http: HttpClient, private _global: Globals, private _common: commonService) {
    this._common.profile.subscribe((data: any) => {
      this.user = data;
    })
  }
  readonly rootUrl = this._global.siteUrl;


  addGroup(formObj) {
    
    return this.http.post(this.rootUrl + 'group/addgroup', formObj);
  }

  getUserGroup(obj) {
    // obj['userId']=this.user.id;
    return this.http.post(this.rootUrl + 'group/getusergroup', obj, { headers: this.reqHeader });

  }

  getGroupDetails(obj) {
  //  obj['userId'] = this.user.id;
    return this.http.post(this.rootUrl + 'group/getgroupdetails', obj,{ headers: this.reqHeader });

  }

  getgroupmemberdetails(obj) {
    //obj['userId'] = this.user.id;
    return this.http.post(this.rootUrl + 'group/getgroupmemberdetails', obj,{ headers: this.reqHeader });
  }

  requestoJoin(obj) {
    //obj['userId']=this.user.id;
    return this.http.post(this.rootUrl + 'group/requestojoin', obj);
  }

  sugesstedGroup(obj) {
    //console.log("here11111111111");
    // obj['userId']=this.user.id;
    return this.http.post(this.rootUrl + 'group/sugesstedgroup', obj, { headers: this.reqHeader });

  }

  delgroup(obj) {
    obj['userId'] = this.user.id;
    return this.http.post(this.rootUrl + 'group/delgroup', obj);
  }

  filteruser(obj) {
    obj['userId'] = this.user.id;
    return this.http.post(this.rootUrl + 'group/filteruser', obj);
  }

  batchuser(obj) {
    obj['userId'] = this.user.id;
    return this.http.post(this.rootUrl + 'group/getuserbatch', obj);

  }

  addinvitation(obj) {
    obj['userId'] = this.user.id;
    return this.http.post(this.rootUrl + 'group/addinvitation', obj);
  }

  addNewPostGroup(obj) {
    obj['userId'] = this.user.id;
    return this.http.post(this.rootUrl + 'group/addpost', obj);
  }

  groupfeed(obj) {
 // obj['userId'] = this.user.id;
    return this.http.post(this.rootUrl + 'group/groupfeed', obj,{ headers: this.reqHeader });
  }

  savePostLike(Obj) {
    return this.http.post(this.rootUrl + 'group/savepostlike', Obj);
  }

  getComments(Obj) {
    // var reqHeader = new HttpHeaders({ 'No-Auth':'True'});
    return this.http.post(this.rootUrl + 'group/getcomments', Obj);
  }

  saveComment(Obj) {
    return this.http.post(this.rootUrl + 'group/savecomment', Obj);
  }

  saveCommentLike(Obj) {
    return this.http.post(this.rootUrl + 'group/savecommentlike', Obj);
  }

  deleteCommentLike(Obj) {
    return this.http.post(this.rootUrl + 'group/deletecommentlike', Obj);
  }

  editComment(Obj) {
    return this.http.post(this.rootUrl + 'group/editcomment', Obj);
  }
  deleteComment(Obj) {
    return this.http.post(this.rootUrl + 'group/deletecomment', Obj);
  }

  saveshortOrder(Obj) {
    return this.http.post(this.rootUrl + 'group/saveshortorder', Obj);
  }

  editPostGroup(Obj) {
    return this.http.post(this.rootUrl + 'group/editpost', Obj);
  }
  deletefeed(Obj) {
    Obj['userId'] = this.user.id;
    return this.http.post(this.rootUrl + 'group/deletefeed', Obj);
  }

  filtergroup(obj) {
    return this.http.post(this.rootUrl + 'group/filtergroup', obj, { headers: this.reqHeader });
    // return this.http.post(this.rootUrl + 'group/filtergroup', obj);  
  }

  addGroupUser(obj){
    return this.http.post(this.rootUrl + 'group/addGroupUser', obj);
  }
  groupUser(obj){
    return this.http.post(this.rootUrl + 'group/groupuser', obj);
  }
  delUserGroup(obj){
    return this.http.post(this.rootUrl + 'group/deluserGroup', obj);
  }
  regeneratepasscode(obj){
    return this.http.post(this.rootUrl + 'group/repasscode', obj);
  }

  makegroupadmin(obj){
    return this.http.post(this.rootUrl + 'group/addgroupadmin', obj);
  }

  getuser(obj){
    return this.http.post(this.rootUrl + 'group/getuser', obj);
  }

  getGroupByUser(obj){
    return this.http.post(this.rootUrl + 'group/getgroupbyuser', obj, { headers: this.reqHeader });
  }

  pintotop(obj){
    return this.http.post(this.rootUrl + 'group/pintotop', obj);
  }

}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/service/group.service.ts